import { createSlice } from "@reduxjs/toolkit";

export interface ConfigState {
  isFetching: boolean;
  prismic: { isLoaded: boolean; data: object };
}

const DEFAULT_STATE: ConfigState = {
  isFetching: true,
  prismic: { isLoaded: false, data: null },
};

export const configSlice = createSlice({
  name: "config",
  initialState: DEFAULT_STATE,
  reducers: {
    updateAttributes: (state, { payload }) => {
      return { ...state, ...payload };
    },
    isFetchingConfig: (state, { payload }) => {
      state.isFetching = payload;
    },
    setPrismicData: (state, { payload }) => {
      state.prismic.isLoaded = true;
      state.prismic.data = payload || null;
    },
  },
});
